/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_UsernameInputs */

const vi_einvoice_credential_username = /** @type {(inputs: Einvoice_Credential_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản MISA`)
};

/**

* @param {Einvoice_Credential_UsernameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_username = /** @type {((inputs?: Einvoice_Credential_UsernameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_UsernameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_username(inputs)
});